import axios from 'axios';
import store from '../index';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
const REFRESH_THROTTLE_MS = 2000;
let refreshTimer = null;

const state = {
	items: [],
	previews: [],
	count: 0,
	sortBy: '',
	sortDesc: '',
	setting: {},
	item: {},
};

const getters = {
	getItems: state => {
		return state.items;
	},
	getItem: state => {
		return state.item;
	},
	getPreviews: state => {
		return state.previews;
	},
	// campanello: conta le notifiche non lette (previews), non la pagina di /notify (items)
	getCount: state => {
		return state.previews.length;
	},
	getSortBy: state => {
		return state.sortBy;
	},
	getSortDesc: state => {
		return state.sortDesc;
	},
	getSetting: state => {
		return state.setting;
	},
};

const actions = {
	addNotify: async (context, payload) => {
		for (let add of payload) {
			await context.commit('addItems', add);
		}
	},
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'notifies/lists';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['notify/getSortBy'],
						sortDesc: context.rootGetters['notify/getSortDesc'],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);
			await context.commit('setItems', res.data.data);
			// letture/cancellazioni fatte da /notify si riflettono subito sul campanello
			context.dispatch('asyncPreviewData');

			return res.data.pagination;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	asyncPreviewData: async (context, settings) => {
		let url = 'notifies';

		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.get(
				`${context.rootGetters['settings/getUrl']}${url}`,

				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				context.commit('setPreviews', res.data.data);
				context.commit('setCount', res.data.pagination.total);
				return res.data.data;

				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},

	// Evento socket NOTIFY_REFRESH: i cron creano notifiche a raffica, si ricarica al massimo
	// una volta ogni REFRESH_THROTTLE_MS (l'ultima chiamata della raffica non va persa).
	refreshPreviews: context => {
		if (refreshTimer) return;
		refreshTimer = setTimeout(() => {
			refreshTimer = null;
			context.dispatch('asyncPreviewData');
		}, REFRESH_THROTTLE_MS);
	},

	// Segna una notifica come letta (is_active:false) e la rimuove subito dall'anteprima.
	disableItem: async (context, item) => {
		let url = 'notifies/update';
		context.commit('removeItem', item._id);
		return await axios
			.put(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{ data: { _id: item._id } },
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => res.data)
			.catch(err => {
				console.log('errore', err?.response?.status);
				return { error: err?.response?.status };
			});
	},

	deleteItems: async (context, settings) => {
		let url = 'notifies/delete';
		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						query: settings,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				return res.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err.response.status);

				return { error: err.response.status };
			});
	},

	destroyData: context => {
		context.commit('setItems', []);
		context.commit('setItem', {});
		context.commit('setIndex', '');
	},
};

const mutations = {
	setItems: async (state, value) => {
		state.items = value;
	},
	addItems: async (state, value) => {
		for (let val of value) {
			state.items.unshift(val);
		}
	},
	removeItem: (state, id) => {
		state.items = state.items.filter(item => item._id !== id);
		state.previews = state.previews.filter(item => item._id !== id);
	},
	setItem: async (state, value) => {
		state.item = value;
	},
	setPreviews: (state, value) => {
		state.previews = value;
	},
	setCount: (state, value) => {
		state.count = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
	setSetting: (state, value) => {
		state.setting = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
